
const getHabitatUrl = () => {
    return process.env.REACT_APP_ENV === 'prod'
    ? 'https://tpses2dg7g.execute-api.us-east-1.amazonaws.com/Prod'
    : 'https://ygwp02r4s9.execute-api.us-east-1.amazonaws.com/Prod';
}
export default class Settings {
    static HabitatUrl = getHabitatUrl();
    static appleStoreUrl = "https://apps.apple.com/app/itrack-habitat/id1612131706";
    static androidStoreUrl = "https://play.google.com/store/apps/details?id=itrack.habitat.mobile";
}